import { TABLE_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers.js";
const pluginTable = (config = {}) => {
  return {
    config,
    type: TABLE_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginTable
};
//# sourceMappingURL=viewer.js.map
